/**
 * Opens a header image mega menu and keeps it open while the pointer
 * is on the menu item or the panel. The panel lives on the header,
 * outside the menu list, because that list clips overflow.
 */
(function () {
  if (window.__sgMegaMenu) return;
  window.__sgMegaMenu = true;

  /**
   * @param {string} value
   */
  function handleize(value) {
    return String(value || '')
      .toLowerCase()
      .normalize('NFKD')
      .replace(/[\u0300-\u036f]/g, '')
      .replace(/[^a-z0-9]+/g, '-')
      .replace(/^-+|-+$/g, '');
  }

  /**
   * @param {HTMLElement} panel
   * @param {HTMLElement} item
   */
  function fillMenuLinks(panel, item) {
    var nav = panel.querySelector('.sg-mega__nav');
    var list = panel.querySelector('.sg-mega__list');
    if (!nav || !list || list.childElementCount) return;

    /** @type {{ title: string, url: string, current: boolean }[]} */
    var links = [];
    var data = item.querySelector('[data-sg-children]');
    if (data) {
      try {
        var parsed = JSON.parse(data.textContent || '[]');
        if (Array.isArray(parsed)) links = parsed;
      } catch {
        links = [];
      }
    }

    if (!links.length) {
      panel.querySelectorAll('.sg-mega__card').forEach(function (card) {
        var title = card.querySelector('.sg-mega__caption');
        var label = title ? title.textContent.trim() : '';
        if (!label) return;
        links.push({
          title: label,
          url: card.getAttribute('href') || '#',
          current: false,
        });
      });
    }

    if (!links.length) return;

    links.forEach(function (entry) {
      var row = document.createElement('li');
      var anchor = document.createElement('a');
      anchor.className = 'sg-mega__nav-link';
      anchor.href = entry.url || '#';
      anchor.textContent = entry.title || '';
      if (entry.current) anchor.setAttribute('aria-current', 'page');
      row.appendChild(anchor);
      list.appendChild(row);
    });
    nav.hidden = false;
  }

  function boot() {
    document.querySelectorAll('.sg-mega-anchor').forEach(bind);
  }

  /**
   * @param {HTMLElement} anchor
   */
  function bind(anchor) {
    if (anchor.dataset.sgBound === 'true') return;

    var handle = anchor.getAttribute('data-sg-mega-handle');
    var panel = anchor.querySelector('.sg-mega');
    if (!handle || !panel) return;

    var item = document.querySelector(
      'header-menu [data-sg-menu="' + handle + '"], header-menu [data-sg-handle="' + handle + '"]'
    );
    if (!item) return;

    anchor.dataset.sgBound = 'true';
    item.classList.add('sg-mega-parent');
    item.removeAttribute('on:pointerenter');
    item.removeAttribute('on:pointerleave');
    item.removeAttribute('on:blur');

    fillMenuLinks(panel, item);

    var submenu = item.querySelector(':scope > .menu-list__submenu');
    if (submenu) submenu.hidden = true;

    var disclosure = item.querySelector('.menu-list__disclosure');
    if (disclosure) disclosure.hidden = true;

    if (!panel.id) panel.id = 'sg-mega-' + handle;
    var link = item.querySelector('a.menu-list__link');
    if (link) {
      link.setAttribute('aria-haspopup', 'true');
      link.setAttribute('aria-controls', panel.id);
      link.setAttribute('aria-expanded', 'false');
    }

    var closeTimer = 0;
    var openToken = 0;

    function open() {
      window.clearTimeout(closeTimer);
      if (anchor.classList.contains('is-open')) return;
      var token = ++openToken;
      requestAnimationFrame(function () {
        requestAnimationFrame(function () {
          if (token !== openToken) return;
          anchor.classList.add('is-open');
          if (link) link.setAttribute('aria-expanded', 'true');
        });
      });
    }

    function close() {
      openToken += 1;
      window.clearTimeout(closeTimer);
      anchor.classList.remove('is-open', 'is-lifted');
      if (link) link.setAttribute('aria-expanded', 'false');
    }

    /**
     * @param {Event} event
     */
    function queueClose(event) {
      var next = /** @type {Event} */ (event).relatedTarget;
      if (
        next instanceof Node &&
        (next === item || next === anchor || item.contains(next) || anchor.contains(next))
      ) {
        return;
      }
      window.clearTimeout(closeTimer);
      closeTimer = window.setTimeout(function () {
        if (item.matches(':hover') || anchor.matches(':hover')) return;
        if (item.contains(document.activeElement) || panel.contains(document.activeElement)) return;
        close();
      }, 450);
    }

    item.addEventListener('pointerenter', open);
    item.addEventListener('pointerleave', queueClose);
    item.addEventListener('focusin', open);
    item.addEventListener('focusout', queueClose);
    panel.addEventListener('pointerenter', open);
    panel.addEventListener('pointerleave', queueClose);

    document.querySelectorAll('header-menu .menu-list__list-item').forEach(function (other) {
      if (other === item) return;
      other.addEventListener('pointerenter', close);
    });

    document.querySelectorAll('.menu-drawer__menu-item-text').forEach(function (label) {
      if (handleize(label.textContent || '') !== handle) return;
      var row = label.closest('li');
      if (!row || row.querySelector('.sg-mega--drawer')) return;
      var copy = panel.cloneNode(true);
      if (!(copy instanceof HTMLElement)) return;
      copy.classList.add('sg-mega--drawer');
      copy.classList.remove('is-open');
      copy.removeAttribute('id');
      row.appendChild(copy);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', boot);
})();
